import '../App.css';
import './Home.css';
import { useNavigate} from "react-router-dom";

const Home = () => {
  const navigation = useNavigate();

  return (
    <div style={{display: "flex"}}>
        
        <div className="backPanel">
            <div className='page-head-group'>
              <h1 className='page-heading'>Hey there! My name is</h1>
              <h1 className='page-heading'>Thomas Dawson</h1>
            </div>
            <div className='page-secondary-group'>
              <p className='page-secondary'>I'm a software developer looking for new opportunities.</p>
              <p className='page-secondary'>Take a look at some of the projects I've worked on!</p>
            </div>
            <div className='button-group'>
              <button className='page-button primary margin-home' onClick={() => navigation('/projects')}>Projects</button>
              <button className='page-button secondary margin-home' onClick={() => navigation('/resume')}>Resume</button>
              
            </div>
        </div>
        
    </div>
  )
}

export default Home